// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-StudyList-StudyListItem-StudyTags-module__tagIcon";
var _2 = "webpack-pages-StudyList-StudyListItem-StudyTags-module__tagList";
export { _1 as "tagIcon", _2 as "tagList" }
